import React, {Component} from "react";
import '../../subjective/Subjective.css'; // todo: move to common location
import '../../EMR.css';
import '../../subjective/views/ComplaintView.css';
import {Grid} from "@material-ui/core";
import {getReviewOfSystemNormalText} from "../checkers/AssessmentReviewOfSystemChecker";

export default class AssessmentReviewOfSystemView extends Component {

    dataFields = [
        {
            title: "Cardiovascular / Circulatory",
            field: "cardiovascularCirculatory"
        }, {
            title: "Respiratory",
            field: "respiratory"
        }, {
            title: "Head, Neck, Eyes",
            field: "headNeckEyes"
        }, {
            title: "ENT",
            field: "ent"
        }, {
            title: "Skin, Hair, Nails",
            field: "skinHairNails"
        }, {
            title: "Lymphatic / Immune",
            field: "lymphaticImmune"
        }, {
            title: "Endocrine",
            field: "endocrine"
        }, {
            title: "Gastrointestinal",
            field: "gastrointestinal"
        }, {
            title: "Genitourinary",
            field: "genitourinary"
        }, {
            title: "Musculoskeletal",
            field: "musculoskeletal"
        }, {
            title: "Neurological",
            field: "neurological"
        },
    ]

    render() {
        if (this.props.reviewOfSystem == null) {
            return (<></>);
        }

        let contents = this.getContents();

        return (
            <div style={{margin: "0px 5px", padding: "15px 0px"}}>
                {contents}
            </div>
        );
    }

    getContents() {
        let contents = [];
        this.dataFields.map(((data, idx) => {
            const field = this.props.reviewOfSystem[data.field];
            const fieldIsNormal = this.props.reviewOfSystem[data.field + "Normal"];
            const statusName = getReviewOfSystemNormalText(fieldIsNormal);
            contents.push(
                <Grid key={idx} container alignItems={"center"} className={"content-card content-row no-margin"}>
                    <Grid item xs style={{maxWidth: 240}} className={"content-card-title"}>
                        <h6 className={"no-margin"}>{data.title}</h6>
                    </Grid>
                    <Grid item xs>
                        <div style={{borderLeft: "1px gainsboro solid", padding: "10px"}}>
                            <div>
                                {(field != null && field.length > 0)
                                    ? field.join(", ")
                                    : statusName}
                            </div>
                        </div>
                    </Grid>
                </Grid>
            );
            contents.push(<br key={"key" + idx}/>);
        }));

        contents.push(<br key={"key"}/>);
        return contents;
    }
}